import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { GetSortTypesInput } from 'src/models/GetSortTypes';
import { getSortTypes, resetGetSortTypesOutput } from 'src/store/common-slices/sortContainerSlice';
import { BatchMoveContainersMode, setBatchMoveMode } from 'src/store/common-slices/batchMoveContainersSlice';
import Sortation from './Sortation';

const mapStateToProps = (state: RootState) => ({
    pageToRender: state.SortContainer.pageToRender,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getSortTypes: (getSortTypesInput: GetSortTypesInput) => dispatch(getSortTypes(getSortTypesInput)),
    resetGetSortTypesOutput: () => dispatch(resetGetSortTypesOutput()),
    setBatchMoveMode: (batchMoveContainersMode: BatchMoveContainersMode) => dispatch(setBatchMoveMode(batchMoveContainersMode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sortation);
